import { InfoPopup } from './InfoPopup';

export default InfoPopup;
